module.exports = __webpack_public_path__ + "img/icon-chat.048ae733.svg";